import { render } from "./TheatreMedia.vue?vue&type=template&id=a089a380"
import script from "./TheatreMedia.vue?vue&type=script&lang=js"
export * from "./TheatreMedia.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__